// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ArrowNarrowLeftDefault } from '../../../assets/icons/default/arrows/arrow-narrow-left.svg?react';
import { ReactComponent as ArrowNarrowLeftSolid } from '../../../assets/icons/solid/arrows/ARROW-NARROW-LEFT.svg?react';
import { createIcons } from '../../Icon';
const ArrowNarrowLeftIcon = /* @__PURE__ */ createIcons('ArrowNarrowLeft', {
    default: ArrowNarrowLeftDefault,
    solid: ArrowNarrowLeftSolid
});
ArrowNarrowLeftIcon.supportedTypes = ['default', 'solid'];
ArrowNarrowLeftIcon.category = 'arrows';
export default ArrowNarrowLeftIcon;
